<template>
	<div
		class="rounded-lg sm:rounded-xl px-4 lg:px-4 pt-2 pb-4 lg:pb-4 shadow bg-white ring-orange-500"
	>
		<div class="grid grid-cols-2 gap-x-4">
			<div class="space-y-3 col-span-2 sm:col-span-1">
				<div v-if="field == 'revenue'" class="contents">
					<h2 class="text-xl sm:text-2xl text-gray-500 font-semibold mb-2">
						{{ __("messages.total_turnover") }}
					</h2>
					<p
						class="text-3xl sm:text-4xl text-gray-700 font-semibold whitespace-nowrap"
					>
						{{
							(1 * totals.revenue).toLocaleString(locale, {
								minimumFractionDigits: 0,
								maximumFractionDigits: 0,
							})
						}}
						€
					</p>
				</div>
				<div v-else class="contents">
					<h2 class="text-xl sm:text-2xl text-gray-500 font-semibold mb-2">
						{{ __("messages.total_quantity") }}
					</h2>
					<p class="text-3xl sm:text-4xl text-gray-700 font-semibold">
						{{
							(1 * totals.qty).toLocaleString(locale, {
								minimumFractionDigits: 0,
								maximumFractionDigits: 0,
							})
						}}
						t
					</p>
				</div>
			</div>
			<div
				class="flex-grow hidden sm:block"
				ref="chart"
				style="width: 100%; height: 200px"
			></div>
		</div>
	</div>
</template>

<script>
import * as echarts from "echarts";

export default {
	props: {
		totals: {
			type: Object,
			default: () => ({ qty: 0, revenue: 0 }),
		},
		dataByYear: {
			type: Array,
			default: () => [],
		},
		field: {
			type: String,
			default: "qty",
		},
	},
	data() {
		return {
			myChart: null,
		};
	},
	mounted() {
		let chartDom = this.$refs.chart,
			that = this,
			option = {
				animation: true,
				animationDuration: 700,
				animationEasing: "cubicOut",
				animationDurationUpdate: 700,
				animationEasingUpdate: "cubicOut",
				xAxis: {
					type: "category",
					data: this.dataByYear.map((z) => z.year),
					// splitLine: {
					//     lineStyle: {
					//         color: '#EBEBEA'
					//     }
					// },
					minorTick: {
						show: true,
					},
					minorSplitLine: {
						show: true,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#DFDFDE",
						},
					},
					axisLabel: {
						textStyle: {
							color: "#757575",
						},
					},
				},
				yAxis: [
					{
						type: "value",
						max:
							1.2 *
							Math.max.apply(
								Math,
								this.dataByYear.map((z) => z[this.field])
							),
						//max: 6100,
						splitLine: {
							show: true,
							lineStyle: {
								color: "#EBEBEA",
							},
						},
						minorTick: {
							show: true,
						},
						minorSplitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#EBEBEA",
							},
						},
					},
					{
						// second yAxis to have a right border
						// type: 'value',
						position: "right",
						axisLine: {
							show: true,
							lineStyle: {
								color: "#EBEBEA",
							},
						},
					},
				],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
					formatter: (params) => {
						let sign = that.field == "revenue" ? " €" : " t";
						return (
							`${params[0].seriesName}: ${params[0].value.toLocaleString(
								that.locale
							)} ` +
							sign +
							` <br />
                                ${
																	params[1].seriesName
																}: ${params[1].value.toLocaleString(
								that.locale
							)}` +
							sign
						);
					},
				},
				series: [
					{
						data: this.dataByYear.map(function (z) {
							return {
								value: z[that.field + "Sell"],
								itemStyle: {
									color: "#96BD0D",
								},
							};
						}),
						type: "bar",
						name: this.__("Sale"),
						barWidth: "30%",
						silent: true,
						stack: "x",
					},
					{
						data: this.dataByYear.map(function (z) {
							return {
								value: z[that.field + "Buy"],
								itemStyle: {
									color: "#f29300",
								},
							};
						}),
						type: "bar",
						name: this.__("Purchase"),
						label: {
							show: true,
							position: "top",
							color: "#454545",
							formatter: function (d) {
								return that.field == "revenue"
									? that.dataByYear[d.dataIndex][that.field].toLocaleString(
											that.locale
									  ) + " €"
									: that.dataByYear[d.dataIndex][that.field].toLocaleString(
											that.locale
									  ) + " t";
							},
						},
						barWidth: "30%",
						silent: true,
						stack: "x",
					},
				],
				textStyle: {
					fontFamily: "Barlow, Roboto, Helvetica, Arial, sans-serif",
					fontSize: "10",
					fontWeight: "500",
				},
				grid: {
					left: "auto",
					right: "1px",
					top: "14px",
					bottom: "21px",
				},
			};

		this.myChart = echarts.init(chartDom);
		this.myChart.setOption(option);
		window.addEventListener("resize", this.onResize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.onResize);
		this.myChart?.dispose();
		this.myChart = null;
	},
	watch: {
		// Chart-Instanz bleibt erhalten; bei Datenaenderung nur Serien-/Achsendaten per
		// setOption aktualisieren -> echarts morpht weich (statt Remount + Balken-Pop-in von 0).
		dataByYear() {
			if (!this.myChart) {
				return;
			}

			let that = this;

			this.myChart.setOption({
				xAxis: {
					data: this.dataByYear.map((z) => z.year),
				},
				yAxis: [
					{
						max:
							1.2 *
							Math.max.apply(
								Math,
								this.dataByYear.map((z) => z[this.field])
							),
					},
				],
				series: [
					{
						data: this.dataByYear.map(function (z) {
							return {
								value: z[that.field + "Sell"],
								itemStyle: { color: "#96BD0D" },
							};
						}),
					},
					{
						data: this.dataByYear.map(function (z) {
							return {
								value: z[that.field + "Buy"],
								itemStyle: { color: "#f29300" },
							};
						}),
					},
				],
			});
		},
	},
	methods: {
		onResize() {
			this.myChart?.resize();
		},
	},
};
</script>
